import { cn } from "@/lib/utils";

// Section page header: overline + title + optional description and right-side actions.
export function PromoPageHeader({ overline, title, description, actions, className, testId }) {
  return (
    <div
      className={cn("flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between", className)}
      data-testid={testId || "page-header"}
    >
      <div className="space-y-1.5">
        {overline && <div className="promo-overline">{overline}</div>}
        <h1 className="text-3xl font-medium tracking-tight sm:text-4xl">{title}</h1>
        {description && <p className="max-w-2xl text-sm text-muted-foreground sm:text-base">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
